<div class="header-container">
    <span class="fs-20px font-weight-bold text-white">{{title}}</span>
    <span class="text-white fs-16px" style="cursor: pointer;" (click)="closeDialog()">
        <i class="fa-solid fa-square-xmark"></i>
    </span>
</div>
<div *ngIf="step === 1" class="w-100 d-flex justify-content-center align-items-center">
  <div class=" d-flex flex-column align-items-center justify-content-center" style="width: 80%;">
    <span class="fs-18px mt-2"><b>Selecciona un servicio a redimir</b></span>

    <!-- <span class="fs-16px mt-4 w-100 text-start"><b>Servicios Individuales</b></span> -->
    <div class="d-flex flex-column align-items-center w-100">
      <div class="servicios-item" *ngIf="checkDisponibilidad(13733)">
          <img src="../../../assets/icons/rotacion.png"/>
          <span style="font-weight: bold; font-size: 14px">Parchado</span>
          <input class="big-checkbox" type="checkbox" [(ngModel)]="servicios[4].checked">
      </div>
      <div class="servicios-item" *ngIf="checkDisponibilidad(13732)">
          <img src="../../../assets/icons/nitrogeno.png"/>
          <span style="font-weight: bold; font-size: 14px">Nitrógeno</span>
          <input class="big-checkbox" type="checkbox" [(ngModel)]="servicios[3].checked">
      </div>
        <div class="servicios-item" *ngIf="checkDisponibilidad(38662)">
          <img src="../../../assets/icons/garantia.png"/>
          <span style="font-weight: bold; font-size: 14px">Garantía <span *ngIf="!checkStock()">(Sin Stock)</span></span>
          <input class="big-checkbox" type="checkbox" [disabled]="!checkStock()" [(ngModel)]="servicios[5].checked">
      </div>
    </div>


    <!-- <div class="divisor-seccion"></div> -->
    
    <!-- <span class="fs-16px mt-2 w-100 text-start"><b>Servicios Grupales</b></span> -->
    <div class="d-flex flex-column align-items-center w-100">
      <div class="servicios-item" *ngIf="checkDisponibilidad(13729)">
          <img src="../../../assets/icons/parchado.png"/>
          <span style="font-weight: bold; font-size: 14px">Balanceo (4 Llantas)</span>
          <input class="big-checkbox" type="checkbox" [(ngModel)]="servicios[1].checked">
      </div>
      <div class="servicios-item" *ngIf="checkDisponibilidad(13728)">
          <img src="../../../assets/icons/balanceo.png"/>
          <span style="font-weight: bold; font-size: 14px">Rotación (4 Llantas)</span>
          <input class="big-checkbox" type="checkbox" [(ngModel)]="servicios[0].checked">
      </div>
    </div>

    <!-- <div class="divisor-seccion"></div> -->

    <!-- <span class="fs-16px mt-2 w-100 text-start"><b>Servicio Vehiculo</b></span> -->
    <div class="d-flex flex-column align-items-center w-100">
      <div class="servicios-item" *ngIf="checkDisponibilidad(13730)">
        <img src="../../../assets/icons/diagnostico-mecanico.png"/>
        <span style="font-weight: bold; font-size: 14px">Diag. Mecánico (Vehículo)</span>
        <input class="big-checkbox" type="checkbox" [(ngModel)]="servicios[2].checked">
      </div>
    </div>

    <div class="w-100 d-flex flex-row justify-content-around align-items-center mt-2">
      <button class="btn btn-secondary" (click)="closeDialog()">Cancelar</button>
      <button class="btn btn-primary" (click)="guardar()">Guardar</button>
    </div>
    <br><br>
  </div>
</div>

<div *ngIf="step !== 1" class="w-100 d-flex justify-content-center align-items-center">
  <div class=" d-flex flex-column align-items-center justify-content-center" style="width: 80%;">
    <span class="mt-2">Toma una fotografía clara de <b>{{getLabelStep()}}</b> <i (click)="abrirImagen()" class="fa-solid fa-circle-info ms-2"></i></span>

    <div *ngIf="step === 2" class="col-12">
      <!-- <span class="fs-14px font-weight-bold">Área dañada</span> -->
      <app-webcam (imageCaptured)="onImage($event)" [opcion]="1" (capturaReiniciada)="desactivarContinuar($event)"></app-webcam>
    </div>
  
    <div *ngIf="step === 3" class="col-12">
      <!-- <span class="fs-14px font-weight-bold">Perfil del neumático</span> -->
      <app-webcam (imageCaptured)="onImage($event)" [opcion]="2" (capturaReiniciada)="desactivarContinuar($event)"></app-webcam>

    </div>
  
    <div *ngIf="step === 4" class="col-12">
      <!-- <span class="fs-14px font-weight-bold">Piso del neumático</span> -->
      <app-webcam (imageCaptured)="onImage($event)" [opcion]="3" (capturaReiniciada)="desactivarContinuar($event)"></app-webcam>
    </div>

    <div class="w-100 d-flex flex-row justify-content-around align-items-center mt-2">
      <button class="btn btn-secondary" (click)="closeDialog()">Cancelar</button>
      <button class="btn btn-primary" [disabled]="getDisabled()" (click)="nextStep()">Guardar</button>
    </div>
    <br><br>
  </div>
</div>